function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.932
    },
    fill: "#FFFFFF",
    d: "M 511.5,384.5 C 511.5,388.5 511.5,392.5 511.5,396.5C 476.758,432.744 441.424,468.577 405.5,504C 398.98,507.526 392.647,507.193 386.5,503C 373.667,490.167 360.833,477.333 348,464.5C 344.28,456.977 344.78,449.81 349.5,443C 341.43,433.524 331.096,428.857 318.5,429C 314.271,427.885 310.271,426.219 306.5,424C 295.667,413.833 284.833,403.667 274,393.5C 270.051,384.479 272.884,379.979 282.5,380C 283.833,380.667 285.167,381.333 286.5,382C 296.196,392.03 306.196,401.697 316.5,411C 325.462,413.414 334.462,415.747 343.5,418C 350.326,421.169 356.159,425.669 361,431.5C 386,406.5 411,381.5 436,356.5C 436.667,355.833 436.667,355.167 436,354.5C 429.624,348.421 425.291,341.088 423,332.5C 421.789,319.541 421.122,306.541 421,293.5C 419.941,290.382 418.608,287.382 417,284.5C 403.167,270.667 389.333,256.833 375.5,243C 367.321,238.781 358.987,238.448 350.5,242C 357,248.5 363.5,255 370,261.5C 372.833,272 369,275.833 358.5,273C 351,265.5 343.5,258 336,250.5C 335.964,270.564 335.298,290.564 334,310.5C 327.031,324.878 315.864,329.878 300.5,325.5C 299.669,332.811 299.169,340.144 299,347.5C 293.19,364.989 281.357,371.323 263.5,366.5C 259.948,376.219 253.282,382.719 243.5,386C 231.5,398 219.5,410 207.5,422C 199.036,427.599 189.703,430.599 179.5,431C 172.191,432.991 166.191,436.991 161.5,443C 166.22,449.81 166.72,456.977 163,464.5C 149.439,478.73 135.272,492.23 120.5,505C 115.373,506.981 110.373,506.648 105.5,504C 82.3333,480.833 59.1667,457.667 36,434.5C 33.3316,427.837 35.4982,423.503 42.5,421.5C 44.1151,422.154 45.7818,422.654 47.5,423C 69.6805,445.347 92.0138,467.514 114.5,489.5C 126.5,478.167 138.167,466.5 149.5,454.5C 117.014,421.514 84.3471,388.68 51.5,356C 50.8333,355.333 50.1667,355.333 49.5,356C 37.9858,367.347 26.6524,378.847 15.5,390.5C 20.1851,395.351 24.6851,400.351 29,405.5C 29.7466,415.048 25.5799,418.215 16.5,415C 10.2306,409.237 4.5639,403.071 -0.5,396.5C -0.5,392.5 -0.5,388.5 -0.5,384.5C 12.572,369.925 26.2387,355.758 40.5,342C 48.1533,338.305 55.4866,338.805 62.5,343.5C 68.5895,338.659 72.0895,332.326 73,324.5C 73.3333,313.5 73.6667,302.5 74,291.5C 75.1672,285.326 77.5006,279.66 81,274.5C 93.4705,261.029 106.304,247.862 119.5,235C 126.967,228.434 135.633,224.267 145.5,222.5C 143.62,218.359 142.453,214.026 142,209.5C 141.071,188.463 141.404,167.463 143,146.5C 144.946,139.942 147.946,133.942 152,128.5C 159.698,121.136 167.031,113.47 174,105.5C 176.96,99.87 178.46,93.87 178.5,87.5C 170.464,87.6293 164.964,83.9626 162,76.5C 161.333,56.5 161.333,36.5 162,16.5C 163.406,11.4268 166.572,7.92678 171.5,6C 222.167,5.33333 272.833,5.33333 323.5,6C 330.351,8.86187 333.851,14.0285 334,21.5C 334.919,40.2051 334.586,58.8717 333,77.5C 329.903,83.9692 324.736,87.3026 317.5,87.5C 316.939,100.04 321.106,110.707 330,119.5C 332.261,123.95 333.928,128.617 335,133.5C 335.333,164.833 335.667,196.167 336,227.5C 337,228.5 338,229.5 339,230.5C 348.514,223.949 359.014,221.783 370.5,224C 376.322,225.245 381.655,227.578 386.5,231C 401.667,244.833 416.167,259.333 430,274.5C 434.392,281.175 436.892,288.509 437.5,296.5C 446.207,296.037 449.707,300.037 448,308.5C 445.409,312.048 441.909,313.382 437.5,312.5C 436.025,324.342 439.358,334.508 447.5,343C 449.807,342.358 452.141,341.358 454.5,340C 460.097,338.909 465.43,339.576 470.5,342C 484.761,355.758 498.428,369.925 511.5,384.5 Z M 177.5,20.5 C 224.168,20.3333 270.835,20.5 317.5,21C 318.833,37.6667 318.833,54.3333 317.5,71C 292.167,71.3333 266.833,71.6667 241.5,72C 236.776,74.4353 235.276,78.2686 237,83.5C 237.5,85.3333 238.667,86.5 240.5,87C 260.831,87.5 281.164,87.6666 301.5,87.5C 300.788,103.73 305.955,117.73 317,129.5C 317.667,131.5 318.333,133.5 319,135.5C 319.667,191.833 319.667,248.167 319,304.5C 313.847,312.788 307.847,313.455 301,306.5C 299.689,275.894 299.023,245.228 299,214.5C 295.108,208.741 290.441,208.074 285,212.5C 284,257.5 283,302.5 282,347.5C 275.196,354.469 269.196,353.802 264,345.5C 263.99,301.083 263.323,256.75 262,212.5C 256.559,208.074 251.892,208.741 248,214.5C 247.667,264.167 247.333,313.833 247,363.5C 240.667,372.833 234.333,372.833 228,363.5C 227.667,313.833 227.333,264.167 227,214.5C 224.459,209.931 220.625,208.431 215.5,210C 214.333,211.167 213.167,212.333 212,213.5C 211.667,257.167 211.333,300.833 211,344.5C 208.307,351.507 203.473,353.674 196.5,351C 194.622,349.457 193.122,347.624 192,345.5C 191.667,297.167 191.333,248.833 191,200.5C 187.509,193.96 182.842,192.96 177,197.5C 175.549,207.729 175.049,218.062 175.5,228.5C 165.639,225.466 159.806,218.8 158,208.5C 157.333,190.5 157.333,172.5 158,154.5C 158.534,150.232 159.867,146.232 162,142.5C 170.333,133.5 178.667,124.5 187,115.5C 192.255,106.903 194.755,97.5697 194.5,87.5C 200.509,87.6662 206.509,87.4995 212.5,87C 217.381,82.6248 217.715,77.9581 213.5,73C 201.601,71.5414 189.601,71.0414 177.5,71.5C 177.5,54.5 177.5,37.5 177.5,20.5 Z M 142.5,239.5 C 148.732,238.939 154.732,239.772 160.5,242C 154,248.5 147.5,255 141,261.5C 138.167,272 142,275.833 152.5,273C 160,265.5 167.5,258 175,250.5C 175.333,283.167 175.667,315.833 176,348.5C 179.825,360.646 188.159,367.313 201,368.5C 204.886,368.069 208.72,367.403 212.5,366.5C 213.915,373.43 217.582,378.93 223.5,383C 214.137,392.697 204.47,402.03 194.5,411C 185.538,413.414 176.538,415.747 167.5,418C 160.674,421.169 154.841,425.669 150,431.5C 125,406.5 100,381.5 75,356.5C 74.3333,355.833 74.3333,355.167 75,354.5C 81.3758,348.421 85.7092,341.088 88,332.5C 89.2112,319.541 89.8778,306.541 90,293.5C 91.0587,290.382 92.3921,287.382 94,284.5C 107.833,270.667 121.667,256.833 135.5,243C 137.925,241.787 140.259,240.621 142.5,239.5 Z M 459.5,355.5 C 472.094,366.425 484.094,378.092 495.5,390.5C 462.833,423.833 429.833,456.833 396.5,489.5C 384.5,478.167 372.833,466.5 361.5,454.5C 394.188,421.479 426.854,388.479 459.5,355.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.859
    },
    fill: "#FFFFFF",
    d: "M 199.5,37.5 C 208.008,37.8329 211.175,42.1662 209,50.5C 206.045,54.2765 202.212,55.4432 197.5,54C 192.699,50.8868 191.532,46.7202 194,41.5C 195.5,39.5313 197.333,38.198 199.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.855
    },
    fill: "#FFFFFF",
    d: "M 151.5,83.5 C 159.168,83.3321 162.335,86.9988 161,94.5C 158.774,98.8608 155.274,100.361 150.5,99C 146.139,96.7742 144.639,93.2742 146,88.5C 147.107,85.887 148.94,84.2203 151.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.849
    },
    fill: "#FFFFFF",
    d: "M 336.5,84.5 C 343.49,82.8383 347.49,85.5049 348.5,92.5C 346.171,100.944 341.338,102.61 334,97.5C 331.606,92.5272 332.44,88.1938 336.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.869
    },
    fill: "#FFFFFF",
    d: "M 126.5,99.5 C 134.839,100.326 137.672,104.659 135,112.5C 132.005,115.265 128.505,116.098 124.5,115C 122.667,114.5 121.5,113.333 121,111.5C 119.036,105.532 120.869,101.532 126.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.864
    },
    fill: "#FFFFFF",
    d: "M 363.5,101.5 C 372.778,100.376 376.278,104.376 374,113.5C 366.691,119.701 361.525,118.201 358.5,109C 359.33,105.809 360.997,103.309 363.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.843
    },
    fill: "#FFFFFF",
    d: "M 102.5,119.5 C 110.658,118.823 114.158,122.49 113,130.5C 110.459,135.069 106.625,136.569 101.5,135C 96.0344,129.434 96.3678,124.267 102.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.852
    },
    fill: "#FFFFFF",
    d: "M 386.5,122.5 C 397.711,122.32 400.711,127.153 395.5,137C 385.846,140.012 381.68,136.512 383,126.5C 384.376,125.295 385.542,123.962 386.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.867
    },
    fill: "#FFFFFF",
    d: "M 83.5,142.5 C 91.6965,142.529 94.8631,146.529 93,154.5C 90.487,158.212 86.987,159.378 82.5,158C 75.8285,152.47 76.1618,147.303 83.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.863
    },
    fill: "#FFFFFF",
    d: "M 407.5,146.5 C 415.696,146.529 418.863,150.529 417,158.5C 414.487,162.212 410.987,163.378 406.5,162C 399.929,156.498 400.262,151.332 407.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.86
    },
    fill: "#FFFFFF",
    d: "M 66.5,168.5 C 77.6642,168.182 80.6642,172.848 75.5,182.5C 65.9412,186.117 61.7746,182.784 63,172.5C 64.3756,171.295 65.5423,169.962 66.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.861
    },
    fill: "#FFFFFF",
    d: "M 424.5,173.5 C 433.002,174.833 435.502,179.5 432,187.5C 422.458,192.307 417.792,189.307 418,178.5C 419.805,176.174 421.972,174.508 424.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.869
    },
    fill: "#FFFFFF",
    d: "M 54.5,196.5 C 65.5275,195.401 68.8609,199.901 64.5,210C 55.6279,214.129 51.1279,211.296 51,201.5C 51.9973,199.677 53.1639,198.01 54.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.848
    },
    fill: "#FFFFFF",
    d: "M 433.5,203.5 C 441.656,202.821 445.156,206.488 444,214.5C 440.108,220.259 435.441,220.926 430,216.5C 427.325,211.011 428.492,206.678 433.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.86
    },
    fill: "#FFFFFF",
    d: "M 47.5,225.5 C 58.6299,225.106 61.6299,229.773 56.5,239.5C 46.9255,243.1 42.7588,239.766 44,229.5C 45.3756,228.295 46.5423,226.962 47.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.86
    },
    fill: "#FFFFFF",
    d: "M 438.5,234.5 C 448.274,232.774 452.107,236.774 450,246.5C 445.333,251.833 440.667,251.833 436,246.5C 434.02,241.933 434.854,237.933 438.5,234.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.852
    },
    fill: "#FFFFFF",
    d: "M 44.5,255.5 C 53.1584,254.327 56.9918,257.994 56,266.5C 52.1273,272.129 47.4606,272.796 42,268.5C 39.6062,263.527 40.4395,259.194 44.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.847
    },
    fill: "#FFFFFF",
    d: "M 440.5,265.5 C 451.832,265.344 454.832,270.177 449.5,280C 439.899,283.07 435.733,279.57 437,269.5C 438.376,268.295 439.542,266.962 440.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.859
    },
    fill: "#FFFFFF",
    d: "M 46.5,285.5 C 57.6299,285.106 60.6299,289.773 55.5,299.5C 45.9255,303.1 41.7588,299.766 43,289.5C 44.3756,288.295 45.5423,286.962 46.5,285.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.843
    },
    fill: "#FFFFFF",
    d: "M 53.5,314.5 C 62.1532,313.987 65.6532,317.987 64,326.5C 61.3981,330.212 57.8981,331.378 53.5,330C 49.1392,327.774 47.6392,324.274 49,319.5C 50.025,317.313 51.525,315.646 53.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.859
    },
    fill: "#FFFFFF",
    d: "M 460.5,379.5 C 469.841,380.004 473.007,384.671 470,393.5C 467.005,396.265 463.505,397.098 459.5,396C 454.931,393.459 453.431,389.625 455,384.5C 456.406,382.256 458.239,380.59 460.5,379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.866
    },
    fill: "#FFFFFF",
    d: "M 324.5,439.5 C 332,440.16 334.833,444.16 333,451.5C 332.5,453.333 331.333,454.5 329.5,455C 319.991,456.495 316.491,452.661 319,443.5C 320.5,441.531 322.333,440.198 324.5,439.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.853
    },
    fill: "#FFFFFF",
    d: "M 177.5,444.5 C 185.662,444.498 188.828,448.498 187,456.5C 184.045,460.277 180.212,461.443 175.5,460C 169.714,453.892 170.381,448.726 177.5,444.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.882
    },
    fill: "#FFFFFF",
    d: "M 112.5,448.5 C 124.569,448.402 127.569,453.569 121.5,464C 111.359,466.863 107.192,463.03 109,452.5C 110.376,451.295 111.542,449.962 112.5,448.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.858
    },
    fill: "#FFFFFF",
    d: "M 295.5,449.5 C 302.808,449.639 305.974,453.305 305,460.5C 302.565,465.224 298.731,466.724 293.5,465C 289.788,462.398 288.622,458.898 290,454.5C 291.107,451.887 292.94,450.22 295.5,449.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.847
    },
    fill: "#FFFFFF",
    d: "M 206.5,452.5 C 214.168,452.332 217.335,455.999 216,463.5C 213.565,468.224 209.731,469.724 204.5,468C 200.788,465.398 199.622,461.898 201,457.5C 202.107,454.887 203.94,453.22 206.5,452.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.867
    },
    fill: "#FFFFFF",
    d: "M 264.5,455.5 C 273.778,454.376 277.278,458.376 275,467.5C 267.997,473.597 262.831,472.264 259.5,463.5C 260.193,460.09 261.86,457.423 264.5,455.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.86
    },
    fill: "#FFFFFF",
    d: "M 234.5,456.5 C 244.031,455.52 247.531,459.52 245,468.5C 240.375,473.684 235.708,473.684 231,468.5C 229.593,463.556 230.759,459.556 234.5,456.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnited);
export default __webpack_public_path__ + "static/media/united.f839c3212f2172ea50bd86c7b0f3a9b3.svg";
export { ForwardRef as ReactComponent };